import React from 'react';
import { useRootStore } from 'mst';
import { PricingCard } from './pricing-card';
import { Plan } from 'core/models/user-manager';
import { useStripeCheckout } from 'common/stripe-context';
import __ from 'core/lib/localization';
import { launchCheckoutInterstitial } from './account-utils/launch-checkout-interstitial';

export const PlanPricingCard = ({ plan }: { plan: Plan }) => {
  const {
    slug,
    price,
    // applePrice,
    normalPrice,
    pricingDescription,
    hasSpecialPricing,
    discountPercentage,
  } = plan;

  const store = useRootStore();
  const isCurrent = store?.userManager?.accountData?.currentPlan === slug;
  const isMonthly = slug === 'monthly';
  const hasDiscountPerc = discountPercentage !== null && discountPercentage > 0;
  const isDiscounted = hasDiscountPerc || (!isMonthly && normalPrice !== price);

  const stripeCheckout = useStripeCheckout();
  const handleCheckout = React.useCallback(() => {
    plan.select().then(result => {
      if (result.interstitialMessageKey) {
        launchCheckoutInterstitial(result, () =>
          stripeCheckout(result.stripeSessionId)
        );
      } else {
        stripeCheckout(result.stripeSessionId);
      }
    });
  }, [plan, stripeCheckout]);

  // console.log({
  //   price,
  //   normalPrice,
  //   isDiscounted,
  // });

  let pricingExplanation = isMonthly
    ? __('Billed monthly', 'plans.billedMonthly')
    : __('$%{price} one-time purchase', 'plans.nOneTimePurchase', {
        price,
      });

  if (isDiscounted) {
    if (isMonthly) {
      pricingExplanation = __('Usually $%{price}/mo', 'plans.usuallyNMonthly', {
        price: normalPrice,
      });
    }
  }
  const displayPrice = isMonthly ? price : (price as number) / 12;

  let ribbonTitle = pricingDescription;

  if (hasSpecialPricing && isDiscounted) {
    ribbonTitle = __(
      '%{pricingDescription}: save %{discountPercentage}%',
      'plans.discountedRibbonTitle',
      {
        pricingDescription,
        discountPercentage,
      }
    );
  } else if (isDiscounted) {
    ribbonTitle = __(
      'Save %{discountPercentage}%',
      'plans.savePercentageRibbonTitle',
      {
        discountPercentage,
      }
    );
  }

  return (
    <PricingCard
      cta={isMonthly ? 'Subscribe' : 'Purchase'}
      // discountPercentage={discountPercentage}
      featureTitle={__('All Lupa stories', 'plans.allLupaStories')}
      interval={'/mo'}
      isCurrent={isCurrent}
      isDiscounted={isDiscounted}
      showOriginalPrice={isDiscounted && !isMonthly}
      normalPrice={normalPrice}
      price={displayPrice}
      ribbonTitle={ribbonTitle}
      showRibbon={hasSpecialPricing || isDiscounted}
      pricingExplanation={pricingExplanation}
      title={isMonthly ? 'Monthly' : '1 year'}
      type={isMonthly ? 'monthly' : 'one-year'}
      onCtaClick={handleCheckout}
    />
  );
};
